import axios, { AxiosError } from 'axios';
import { GetPresignedUrlResponse } from '../types/location';
import { ToastHelper, ToastMessageType, ToastType } from './toast';
import { LogType, sendLogMessageToApi } from '../mutations/LogMessageMutation';

export const uploadFileToS3 = async (
  file: File,
  presignedResponse: GetPresignedUrlResponse,
  md5Hash: string,
) => {
  try {
    await axios.put(presignedResponse.data.url, file, {
      headers: {
        'Content-Type': file.type,
        'Content-MD5': md5Hash,
        'Cache-Control': 'no-cache',
        'x-amz-meta-username': presignedResponse.data.username,
      },
    });
  } catch (error) {
    const errorObject = error as AxiosError;

    try {
      await sendLogMessageToApi({
        message: errorObject.message,
        type: LogType.Error,
      });
    } catch (logError) {
      console.error('Failed to send log message:', logError);
    }

    ToastHelper.showToast(
      `Upload to S3 file storage failed. Please re-upload file:  ${error}`,
      ToastType.ERROR,
      ToastMessageType.CUSTOM_ERROR,
    );
  }
};
